module.exports = __webpack_public_path__ + "img/35.5ea3bc0a.png";